import classNames from 'classnames'

import { Button } from '../button/button.js'
import { Sheet } from '../sheet/sheet.js'
import './filter-sheet.scss'

export interface FilterSheetOption {
    value: string
    label: string
}

export interface FilterSheetSection {
    key: string
    label: string
    options: FilterSheetOption[]
    value: string
    onChange: (value: string) => void
}

export interface FilterSheetProps {
    isOpen: boolean
    title: string
    clearLabel: string
    onClear: () => void
    sections: FilterSheetSection[]
    /** e.g. "Näita 6 märki" — closes the sheet. */
    applyLabel: string
    onClose: () => void
}

/**
 * Bottom sheet with chip groups (status / category / sort) that apply at once; the footer
 * button only closes it (Nele's mobile badges design, variant C, 22.10.2026).
 */
export const FilterSheet = (props: FilterSheetProps) => (
    <Sheet
        isOpen={props.isOpen}
        title={props.title}
        onClose={props.onClose}
        titleAction={
            <button type="button" className="filter-sheet__clear" onClick={props.onClear}>
                {props.clearLabel}
            </button>
        }
        footer={<Button text={props.applyLabel} variant="primary" onClick={props.onClose} />}
    >
        {props.sections.map((section, sectionIndex) => (
            <div key={section.key} className="filter-sheet__section">
                <div className="filter-sheet__label" id={`filter-sheet-${section.key}`}>
                    {section.label}
                </div>
                <div
                    className="filter-sheet__chips"
                    role="radiogroup"
                    aria-labelledby={`filter-sheet-${section.key}`}
                >
                    {section.options.map((option) => {
                        const isChecked = option.value === section.value
                        return (
                            <button
                                key={option.value}
                                type="button"
                                role="radio"
                                aria-checked={isChecked}
                                // BaseModal does not move focus into the dialog: land on the first group's choice.
                                autoFocus={sectionIndex === 0 && isChecked}
                                className={classNames(
                                    'filter-sheet__chip',
                                    isChecked && 'filter-sheet__chip--active',
                                )}
                                onClick={() => section.onChange(option.value)}
                            >
                                {option.label}
                            </button>
                        )
                    })}
                </div>
            </div>
        ))}
    </Sheet>
)
